import angular from 'angular';
import CSMCommonWeb from 'csm-common-web';
import attendeeReportDialogTemplate from './AttendeeReportDialog.template.html';

export default angular
  .module('eventsAdmin.services.AttendeeReportDialog', [CSMCommonWeb])
  .service('AttendeeReportDialog', Service)
  .name;

/*******************************************************************************
 * Service: AttendeeReportDialog
 *
 * Utility to show a dialog to generate event attendee reports.
 *******************************************************************************/
/* @ngInject */ function Service($uibModal) {
  /****************************************************************************
   * show */
  /**
   * Show the modal dialog for generating attendee reports.
   *
   * @param   event       Event to generate a report for.
   ****************************************************************************/
  this.show = function (event) {
    return $uibModal.open({
      animation: true,
      backdrop: 'static',
      controller: AttendeeReportDialogController,
      resolve: {
        event: function () {
          return event;
        }
      },
      size: 'sm',
      template: attendeeReportDialogTemplate
    }).result;
  };
}

/** Dialog Controller. */
/* @ngInject */
var AttendeeReportDialogController = function ($scope, event) {
  /** Status types */
  $scope.dpStatus = [
    { name: 'All', code: '' },
    { name: 'Attending', code: 'A' },
    { name: 'Attended', code: 'AD' },
    { name: 'Not Attended', code: 'NA' }
  ];

  /*************************************************************************
   * generateReport */
  /**
   * Builds the report in a new window.
   *************************************************************************/
  $scope.generateReport = function () {
    /*------------------*/
    /* Request payload. */
    /*------------------*/
    var payload = {
      eventID: event.id,
      status: $scope.selectedStatus.code,
      reportFormat: $scope.reportFormat
    };

    /*---------------------------------------*/
    /* Post JSON request to service handler. */
    /*---------------------------------------*/
    JSON.postTo(payload, 'AttendeesReport.aspx', 'request', '_blank');
  };

  /***************************************************************************
   * init */
  /**
   * Set up the dialog.
   ***************************************************************************/
  function init() {
    /*--------------------------------------*/
    /* Preselect the dialog default values. */
    /*--------------------------------------*/
    $scope.eventName = event.name;
    $scope.selectedStatus = $scope.dpStatus[0];
    $scope.reportFormat = 'PDF';
  }

  /*--------------------*/
  /* Initialize dialog. */
  /*--------------------*/
  init();
};
